import * as z from "zod";
import { requiredString } from "components/form/utils";

export const skillSchema = z.object({
  name: requiredString(),
  logo: z.optional(z.string()).nullable(),
});
